export default "__VITE_ASSET__f9S5gVs1__"